<template>
  <div class="article-detail">
    <div
      ref="featuredImage"
      class="featured-image"
      :style="{ backgroundImage: 'url(' + data.featuredimage + ')' }">
      <div class="featured-caption">
        <h1>{{ data.title }}</h1>
        <p>{{ updateExcerpt }}</p>
      </div>
      <button
        class="scroll-down"
        :class="{hide: isScrollerClicked}"
        @click="scrollDown"
      >
        <div class="icon-border">
          <span class="icon icon-circle-left"></span>
        </div>
      </button>
    </div>
    <article id="detail-article" class="detail-article container">
      <div class="row row-detail" v-html="data.content" ref="r-article">
      </div>
      <link-home></link-home>
    </article>
  </div>
</template>

<script>
import ScrollMagic from 'ScrollMagic'
import { TweenLite, Power2 } from 'gsap'
// eslint-disable-next-line
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import LinkHome from '@/components/LinkHomeButton'
let smController = {}
let smScenes = []

export default {
  data () {
    return {
      isScrollerClicked: false,
      blogTitle: ''
    }
  },
  metaInfo: {
    title: this.blogTitle,
    titleTemplate: '%sYUYAMA DESIGN INC. | ブランディング&デザイン | デザインコンサルティング'
  },
  props: {
    data: Object
  },
  components: {
    LinkHome
  },
  methods: {
    scrollDown (e) {
      // const elm = this.$refs.detailcontent
      // console.log(this.$refs.detailcontent.offsetTop)
      // console.log(window)
      e.preventDefault()
      // const scrollPlugin = ScrollToPlugin
      this.isScrollerClicked = true
      TweenLite.to(window, 1, { scrollTo: {y: '#detail-article', autoKill: false}, ease: Power2.easeOut })
    },
    appearContent (event) {
      if (event.scrollDirection === 'FORWARD') {
        // console.log(event.currentTarget.triggerElement());
        event.currentTarget.triggerElement().classList.add('active')
      }
    },
    loadComplete () {
      console.log('loadcomplete')
      // this.$store.state.isPageLoaded = true
      this.setupVideoPlayer()
    },
    setupVideoPlayer () {
      const self = this
      const videoContainers = document.getElementsByClassName('wp-block-video')
      for (let i = 0; i < videoContainers.length; i++) {
        const playPauseElm = document.createElement('button')
        const muteElm = document.createElement('button')
        const video = videoContainers[i].getElementsByTagName('video')[0]
        video.muted = false
        playPauseElm.classList.add('control-play', 'icon', 'icon-video-play')
        playPauseElm.addEventListener('click', function () {
          let classes = self.toArray(this.classList)
          // console.log(classes.findIndex((name) => name.match(/icon-video-/)))
          this.classList.remove(classes.find((name) => name.match(/icon-video-/)))
          if (video.paused) {
            video.play()
            this.classList.add('icon-video-pause')
          } else {
            video.pause()
            this.classList.add('icon-video-play')
          }
        })
        muteElm.classList.add('control-mute', 'icon', 'icon-video-sound')
        muteElm.addEventListener('click', function () {
          let classes = self.toArray(this.classList)
          this.classList.remove(classes.find((name) => name.match(/icon-video-/)))
          if (video.muted) {
            video.muted = false
            this.classList.add('icon-video-sound')
          } else {
            video.muted = true
            this.classList.add('icon-video-muted')
          }
        })
        muteElm.classList.add('control-mute')
        videoContainers[i].append(playPauseElm)
        videoContainers[i].append(muteElm)
      }
    }
  },
  mounted () {
    smController = new ScrollMagic.Controller()
    smScenes = []
    const articleItems = this.$refs['r-article'].children
    const contentArr = Array.prototype.slice.call(articleItems) // Sanitize HTMLCollection to Array
    contentArr.forEach(elm => {
      elm.classList.add('sm-anime')
      let smScene = new ScrollMagic.Scene({
        triggerElement: elm,
        triggerHook: 1
      })
        .on('enter', this.appearContent)
        .addTo(smController)
      smScenes.push(smScene)
    })

    // console.log('title: ', this.data.title)
    this.$store.watch(
      (state, getters) => {
        if (state.isPageLoaded === true) {
          this.loadComplete()
        }
      }
    )
  },
  updated () {
    this.blogTitle = this.data.title + ' | '
  },
  computed: {
    updateExcerpt () {
      if (this.data.workexcerpt === undefined) return ''
      return this.data.workexcerpt.replace(/[\n]/g, ' / ')
    }
  },
  beforeDestroy () {
    smController = smController.destroy(true)
    smScenes.forEach(scene => {
      scene = scene.destroy(true)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ArticleDetail.vue